<template>
    <div>
        <h2 class="ix-page-title-secondary">Factures fournisseurs associées</h2>
        <div class="ix-table-box" v-show="company_id && company_id != null">
            <div class="ix-table">
                <table class="ix-table ix-table-sm"">
                    <thead>
                        <tr>
                            <th>Numéro</th>
                            <th class="text-center">Total HT</th>
                            <th class="text-right">Reste à payer TTC</th>
                            <th class="text-right">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(bill, index) in bills" :key="index" v-if="!loading">
                            <td>
                                {{ bill.full_designation }}
                                <input type="hidden" :name="'bills[' + index + '][id]'" v-model="bill.id" required>
                                <input type="hidden" :name="'bills[' + index + '][full_designation]'" v-model="bill.full_designation" required>
                            </td>
                            <td class="text-center">
                                {{ currency(bill.total_ht) }}
                                <input type="hidden" :name="'bills[' + index + '][total_ht]'" v-model="bill.total_ht" required>
                                <input type="hidden" :name="'bills[' + index + '][total_ttc]'" v-model="bill.total_ttc" required>
                            </td>
                            <td class="text-right">
                                 {{  currency(bill.amount) }}
                            </td>
                            <td class="text-right">
                                <button type="button" class="btn btn-sm transparent" @click="deleteRowBill(index)">
                                    <i class="far fa-trash"></i>
                                </button>
                            </td>
                        </tr>
                        <tr v-if="loading">
                            <td colspan="4" class="text-center">
                                <i class="far fa-circle-notch fa-spin"></i>
                            </td>
                        </tr>
                        <tr v-show="!loading && bills.length == 0">
                            <td colspan="5">
                                <input placeholder="Commencer la saisie pour obtenir des suggestions .." class="form-control"
                                    id="billSearchInput" type="text" v-model="bill">
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="row mt-4" v-show="company_id && company_id != null">
            <div class="col-sm-12 col-md-12 col-lg-8 offset-lg-4">
                <div class="ix-trade-totals">
                    <table class="ix-table ix-table-transparent">   
                        <tbody>
                            <tr>
                                <td style="width: 150px;" class="ix-text-bold">Total HT</td>
                                <td class="text-right">
                                    <div class="input-group input-group-sm">
                                        <input type="number" step="0.01" class="form-control text-right" required
                                            v-model="total_ht" id="total_ht" name="total_ht">
                                        <div class="input-group-append">
                                            <span class="input-group-text" id="inputGroup-sizing-sm">€</span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="ix-table ix-table-no-borders">
                        <tbody>
                            <tr>
                                <td colspan="2" class="ix-text-bold">TVA</td>
                            </tr>
                            <tr v-for="(vat, index) in vats" v-bind:key="index">
                                <td style="width: 150px;">
                                    <div class="input-group input-group-sm">
                                        <input type="number" step="0.01" class="form-control text-center" required min="0"
                                            v-model="vat.rate" :name="'vats[' + index + '][rate]'" v-on:change='editVat(index)'>
                                        <div class="input-group-append">
                                            <span class="input-group-text" id="inputGroup-sizing-sm">%</span>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="input-group input-group-sm">
                                        <input type="number" step="0.01" class="form-control text-right" required
                                            v-model="vat.amount" :name="'vats[' + index + '][amount]'">
                                        <div class="input-group-append">
                                            <span class="input-group-text" id="inputGroup-sizing-sm">€</span>
                                            <button class="ix-btn ix-btn-sm icon" type="button" @click="deleteRow(index)"
                                                v-if="vats.length > 1">
                                                <i class="far fa-trash"></i>
                                            </button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2">
                                    <button @click="addRow(null)" type="button" class="ix-btn link"><i
                                            class="far fa-plus"></i> Ajouter une TVA</button>
                                </td>
                            </tr>
                            <tr>
                                <td class="ix-text-bold">Total TVA</td>
                                <td class="text-right">
                                    {{ currency(total_vat) }}
                                    <input type="hidden" v-model="total_vat" name="total_vat">
                                </td>
                            </tr>
                        </tbody>
                    </table>


                    <table class="ix-table ix-table-transparent">
                        <tbody>
                            <tr>
                                <td style="width: 150px;" class="ix-text-bold">Total TTC</td>
                                <td class="text-right">
                                    <div class="input-group input-group-sm">
                                        <input type="number" step="0.01" class="form-control text-right" v-model="total_ttc"
                                            id="total_ttc" name="total_ttc" disabled>
                                        <div class="input-group-append">
                                            <span class="input-group-text" id="inputGroup-sizing-sm">€</span>
                                        </div>
                                        <input type="hidden" v-model="total_ttc" name="total_ttc">
                                        <input type="hidden" v-model="billId" name="bill_id">
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    
                </div>
            </div>
        </div>

        <div v-if="company_id == ''" class="alert alert-warning">
            Veuillez choisir un fournisseur pour choisir une facture fournisseur
        </div>
    </div>
</template>

<script>    
    import $ from "jquery";

    export default {
        name: 'BillCreditSupplierForm',
        props: ['totalHt', 'oldVats', 'billRoute', 'oldBills'],
        data() {
            return {
                vats: [],
                loading: true,
                bill: null,
                bills: [],
                company_id: null,
                total_ht: this.totalHt ? this.totalHt : 0,
                billId: null,
                excludeState: [6],
            }
        },
        computed: {
            total_vat: function () {
                var sum = 0;
                this.vats.forEach(vat => sum += parseFloat(vat.amount));
                return sum;
            }, 
            total_ttc: function () {
                return (this.roundCurrency(parseFloat(this.total_ht) + parseFloat(this.total_vat), 2)) ;
            },
           /* total_ht: function () {
                var sum = 0;
                this.bills.forEach(bill => sum += parseFloat(bill.amount));
                return this.roundCurrency(sum, 2);
            },*/
        },
        watch: {
            total_ht: function(){
                var sum = 0;
                this.vats.forEach(vat => {
                    vat.amount = parseFloat((vat.rate / 100)) * this.total_ht 
                });
            }
        },
        methods: {
            getCurrentSelectedBillsId : function(){
                return this.bills.map(bill => bill.id);
            },
            addRow: function (bill) {
                this.vats.push({
                    'rate': bill != null ? bill.rate : 20,
                    'amount': bill != null ? bill.amount : parseFloat((20 / 100)) * this.total_ht 
                });
            },
            deleteRow: function (index) {
                this.vats.splice(index, 1)
                if (this.vats.length == 0) {
                    this.addRow(null)
                }
            },
           initBillInput : function(){
                $("#billSearchInput").autocomplete({
                    minLength: 0,
                    source: (request, response) => {
                        $.ajax({
                            url: this.billRoute,
                            type: 'get',
                            dataType: 'json',
                            headers: this.getHttpJsonRequestHeaders().headers,
                            data: { 
                                q: request.term, 
                                '!id': this.getCurrentSelectedBillsId().join(';'), 
                                'company_id': this.company_id != null ? this.company_id : null,
                                '!state': this.excludeState.join(';')
                            },
                            success: (data) => {
                                response($.map(data, (item) => {
                                    return Object.assign(item, {
                                        label: item.full_designation,
                                        value: item.full_designation,
                                        formated_total_remaining: this.currency(item.total_remaining),
                                        total_ht: item.total_ht,
                                        formatted_total_ht: this.currency(item.total_ht),
                                        total_ttc: item.total_ttc,
                                        formatted_total_ttc: this.currency(item.total_ttc),
                                        amount: item.total_remaining,
                                    })
                                }))
                            }
                        });
                    },
                    create: function () {
                        $(this).data('ui-autocomplete')._renderItem = (ul, item) => {
                            var html = `<div class="d-flex align-items-center justify-content-between">
                                            <span>${item.full_designation} (${item.company.name})</span>
                                            <span>${item.formatted_total_ht} HT</span>
                                            <span>${item.formatted_total_ttc} TTC</span>
                                            <span>Reste à payer : ${item.formated_total_remaining} TTC</span>
                                        </div>`;
                            return $('<li>')
                                .append(html)
                                .appendTo(ul);
                            };
                    },
                    change: (e, item) => {
                        if (!item.item) {
                            $(e.target).val("");
                            this.bill = null
                        }
                    },
                    select: (e, item) => {
                        if (item.item) {
                            this.addRowBill(item.item)

                            $(e.target).val("")
                            this.bill = null;
                        }
                    }   
                    }).focus(() => {
                        $("#billSearchInput").autocomplete("search", '');
                    });
           },
           addRowBill : function(bill){
            if (this.getCurrentSelectedBillsId().includes(bill.id) == false) {
                this.bills[0] = {
                    id: bill.id,
                    full_designation: bill.full_designation,
                    amount: bill.amount ? bill.amount : (bill.total_remaining ? bill.total_remaining : 0),
                    total_ht: bill.total_ht,
                    total_ttc: bill.total_ttc,
                };

                this.total_ht =  this.totalHt ? this.totalHt : (bill.total_ht ? bill.total_ht : 0);
                this.billId = bill.id;
            }
           },
           deleteRowBill : function(index){
                this.bills.splice(index, 1)
                this.billId = null;
           },
           editVat: function(index){
                if(this.vats[index]){
                    this.vats[index].amount = parseFloat(this.vats[index].rate / 100) * this.total_ht;
                }
           },
           
        },
        mounted() {
            const vm = this;
            if ($('#company_id').val() != null || $('#company_id').val() != '') {
                vm.company_id = $('#company_id').val();
            }
            $('#company_id').on('change', function () {
                vm.company_id = $('#company_id').val();
                vm.bills = [];
            })
            this.initBillInput();


            const jsonBillBackup = JSON.parse(this.oldBills);
            if (Array.isArray(jsonBillBackup)) {
                if (jsonBillBackup.length > 0) {
                    jsonBillBackup.forEach(bill => {
                        this.addRowBill(bill)
                        console.log(bill);
                    })
                }
            }

            const jsonVatsBackup = JSON.parse(this.oldVats);
            if (Array.isArray(jsonVatsBackup)) {
                if (jsonVatsBackup.length > 0) {
                    jsonVatsBackup.forEach(vat => {
                        this.addRow(vat)
                    })
                } else {
                    this.addRow(null);
                }
            } 

            this.loading = false
        }
    }
</script>